module.exports = __webpack_public_path__ + "img/login-landscape.d4e203f0.jpg";